// BNB
export const DEFAULT_INPUT_CURRENCY = 'SGB'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0xB2cD91b79df296ea181AA5f6d729E5136e1853A4'
